import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { XmDirectivesModule, XmSidebarModule, XmPreloaderModule, XmDropdownModule, XmButtonModule } from '@optek/xm-bootstrap';
import { NotificationModule } from '@shared/notification/notification.module';
import { FullComponent } from './full.component';
import { BreadcrumbModule } from './header/breadcrumb/breadcrumb.module';
import { HeaderModule } from './header/header.module';
import { NavBarModule } from './nav-bar/nav-bar.module';
import { NavBarService } from './nav-bar/nav-bar.service';
import { ProfileOverlayComponent } from './profile-overlay/profile-overlay.component';
import { DropdownNotificationsComponent } from './profile-overlay/dropdown-notifications/dropdown-notifications.component';
import { NotificationComponent } from './profile-overlay/dropdown-notifications/notification/notification.component';

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    RouterModule,
    XmDirectivesModule,
    XmSidebarModule,
    NavBarModule,
    BreadcrumbModule,
    NotificationModule,
    HeaderModule,
    XmPreloaderModule,
    XmDropdownModule,
    XmButtonModule
  ],
  declarations: [
    FullComponent,
    ProfileOverlayComponent,
    DropdownNotificationsComponent,
    NotificationComponent
  ],
  providers: [
    NavBarService
  ]
})
export class FullModule { }
